import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { getTailoredAudits } from "./controller/get-tailored-audits"

export function TailoredAudits({ children }) {
    const {
        target: { version, id },
        tailoringReferenceId: referenceId,
    } = useBoundContext()

    const reviews = getTailoredAudits.useResults({ referenceId, scheduleVersion: version, scheduleId: id }) ?? []
    const groupedReviews = reviews?.keyBy("payload.taskId")

    return <Bound tailoredAudits={groupedReviews}>{children}</Bound>
}
